// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-672d95f9] .ant-checkbox-wrapper + .ant-checkbox-wrapper {\n  margin-left: 0;\n  margin-right: 8px;\n}\n.tip[data-v-672d95f9] {\n  color: #bfbfbf;\n  font-size: 16px;\n  line-height: 30px;\n}", ""]);
// Exports
module.exports = exports;
